import { HttpClient } from "@angular/common/http";
import { IResponseService } from "../interfaces/response-service";
import { SectionsService } from "../services/sections.service";
import { MenuModel } from "../shared/models/menu-model";
import { DonacionModel } from "../shared/models/donacion-model";
import { UserModel } from "../shared/models/user-model";
import { ZeroPaperModel } from "../shared/models/zero-paper-model";

export class MainStore {

  public static ORIGIN: number = 1;
  private static instance: MainStore;

  /**
   * @author Jose Wilson Mulato
   * @description metodo por el cual obtiene el unico lugar de almacenamiento de los formulario del cliente
   */
  public static get db() {
    return this.instance || (this.instance = new MainStore());
  }

  private data: ZeroPaperModel;
  private sectionsService: SectionsService = undefined;

  constructor() {
    this.RestData();
  }

  /**
   * @author Jose Wilson Mulato
   * @description Se asigna la instacia de http, para solitar su servicio
   * @param http HttpClient
   */
  public SetHttpClient(http: HttpClient) {
    this.sectionsService = new SectionsService(http);
  }

  /**
   * @author Jose Wilson Mulato
   * @description Limpia todos los valores
   */
  public RestData() {
    this.data = new ZeroPaperModel();
  }
  

  /**
   * @author Jose Wilson Mulato
   * @description Obtener el usuario que esta logueado
   */
  public GetUser() {
    if(this.data == null) {
      this.data = new ZeroPaperModel();
      this.data.user.username = 'dncani04';
      this.data.user.numDoc = 94412240;
      this.data.user.username = 'edward'
    }
    return this.data.user;
  }



  /**
   * @author Jose Wilson Mulato
   * @description Establese el usuario que va usar la aplicación
   * @param user UserModel
   */
  public SetUser(user: UserModel) {
    this.data.user = user;
  }

  /**
   * @author Jose Wilson Mulato
   * @description Oteniendo el menú agregado
   */
  public GetMenu(): MenuModel[] {
    return this.data.menu;
  }

  /**
   * @author Jose Wilson Mulato
   * @description Agregando al menú items
   * @param item
   */
  public AddMenu(...items: MenuModel[]) {
    items.forEach(x => this.data.menu.push(x));
  }

  /**
   * @author Jose Wilson Mulato
   * @description Agregando al menú items
   */
  public ClearMenu() {
    this.data.menu = [];
  }    
  
  /**
   * @author Jose Wilson Mulato
   * @description Guarda la primera section 'Datos Personales'
   * @param data
   */
  async SetDonacion(data: DonacionModel) {
    return new Promise((success, fail) => {     
      this.SaveSection("saveDonacion", data)
        .then((response: IResponseService) => {          
          success(response);
        })
        .catch(error => {
          fail(error);
        });
    });
  }

  /**
   * @author Jose Wilson Mulato
   * @description Envia dinamicamente a los servicios correspondientes y adiciona en los atributtos IP, Usuario Creacion,  Usuario Modificación
   * @param funt el servicio que se va a llamar para guardar
   * @param data el dato que se va enviar a guardar
   */
  private async SaveSection(funt: string, data: any) {    
    return new Promise((success, fail) => {
      this.sectionsService[funt](data)
        .then(response => {
          success(response);
        })
        .catch(error => {
          fail(error);
        });
    });
  }
  
}



// WEBPACK FOOTER //
// ./src/app/store/main-store.ts